export enum Roles {
	ADMIN = "ROLE_ADMIN",
	USER = "ROLE_USER",
	PARTNER = "ROLE_PARTNER",
	SELLER = "ROLE_SELLER"
}
